const headerComponent = document.getElementsByClassName('header')[0];

if (headerComponent) {
  // Header scroll
  const scrollContainer = () => document.documentElement || document.body;

  document.addEventListener('scroll', () => {
    if (scrollContainer().scrollTop > 200) {
      headerComponent.classList.add('scrolled');
    } else if (scrollContainer().scrollTop == 0) {
      headerComponent.classList.remove('scrolled');
    }
  });

  const mobileMenuStartPoint = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
      '--mobile-menu-start-point'
    )
  );
  let isMobileMenuEnable =
    window.outerWidth <= mobileMenuStartPoint ||
    document.querySelector('.header-mobile');

  const dropdownToggle = document.querySelectorAll('.dropdown-toggle');

  dropdownToggle.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      if (isMobileMenuEnable) {
        const menuItem = this.closest('.menu-item.dropdown');
        const dropdownMenu = this.nextElementSibling;

        // close all opened sub menu
        const activeDropdowns = document.querySelectorAll(
          '.menu-item.dropdown.active .dropdown-menu'
        );
        activeDropdowns.forEach((menu) => {
          menu.style.display = 'none';
          menu.closest('.dropdown').classList.remove('active');
        });

        // open current submenu
        menuItem.classList.toggle('active');
        if (menuItem.classList.contains('active')) {
          e.preventDefault();
          dropdownMenu.style.display = 'block';
        }
      }
    });
  });

// toggle menu handler
  function menuToggleFunc() {
    const menuToggle = document.querySelector('.menu-toggle');
    const navbarNav = document.querySelector('.navbar-nav');
    const headerCloseWrapper = document.querySelector('.header-close-wrapper');
    const headerEl = document.querySelector('.header')

    console.log(headerEl);

    menuToggle.classList.toggle('active');
    navbarNav.classList.toggle('active');
    headerCloseWrapper.classList.toggle('active');
    headerEl.classList.toggle('opened');

    // LockScroll when burger open and enable when closed and enable scroll on menu
    if (scrollLock.getScrollState()) {
      scrollLock.disablePageScroll(document.querySelector('.simplebar-content-wrapper'));
      // scrollLock.addScrollableSelector('.simplebar-content-wrapper');
    } else {
      scrollLock.enablePageScroll();
    }
  }

// menu update function
  function updateMenu() {
    isMobileMenuEnable =
      window.outerWidth <= mobileMenuStartPoint ||
      document.querySelector('.mobile-header');

    if (!isMobileMenuEnable) {
      const dropdownMenus = document.querySelectorAll('.dropdown-menu');
      dropdownMenus.forEach((menu) => {
        menu.style.display = '';
      });

      const headerCloseWrapper = document.querySelector('.header-close-wrapper');
      headerCloseWrapper.classList.remove('active');

      const activeMenuItems = document.querySelectorAll('.menu-item.active');
      activeMenuItems.forEach((item) => {
        item.classList.remove('active');
      });

      const navbarNav = document.querySelector('.navbar-nav');
      navbarNav.classList.remove('active');

      const menuToggle = document.querySelector('.menu-toggle');
      menuToggle.classList.remove('active');

      // LockScroll when burger open and enable when closed
      scrollLock.enablePageScroll();
    }
  }

  window.addEventListener('resize', updateMenu);
  window.addEventListener('orientationchange', updateMenu);

// end of toggle menu handler

  const menuToggle = document.querySelector('.menu-toggle');
  const headerCloseWrapper = document.querySelector('.header-close-wrapper');
// const headerBlur = document.querySelector('.header-blur')

  menuToggle.addEventListener('click', menuToggleFunc);
  headerCloseWrapper.addEventListener('click', menuToggleFunc);

// Hide and show Header when scroll up
  function headerSticky() {
    let prevScrollPos = window.pageYOffset;

    window.onscroll = () => {
      const currentScrollPos = window.pageYOffset;
      const headerHeight = headerComponent.scrollHeight;

      if (window.scrollY > 0) {
        if (prevScrollPos > currentScrollPos) {
          headerComponent.style.top = 'var(--header-top, 28px)';
          headerComponent.classList.add('scrolled');
          // headerBlur.classList.remove('active')
        } else {
          headerComponent.style.top = `calc(-${headerHeight}px - var(--header-top, 28px))`;
          headerComponent.classList.remove('scrolled');
          // headerBlur.classList.add('active');
        }
      }

      if (window.scrollY === 0) {
        headerComponent.classList.remove('scrolled');
        // headerBlur.classList.add('active')
      }

      prevScrollPos = currentScrollPos;
    };

    if (window.scrollY !== 0) {
      headerComponent.classList.add('scrolled');
    }
  }

  headerSticky();

  document.addEventListener('DOMContentLoaded', () => {
    const headerSecond = document.querySelector('.header-second');
    const footer = document.querySelector('.footer');

    if (!headerSecond || !footer) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          headerSecond.classList.add('stuck-to-footer');
        } else {
          headerSecond.classList.remove('stuck-to-footer');
        }
      },
      {
        root: null, // viewport
        threshold: 0,
      }
    );

    observer.observe(footer);
  });

  if (document.getElementsByClassName('menu')[0]) {
    const menuList = document.querySelector('.menu__list');
    const menuToggleItemArr = menuList.querySelectorAll('.menu__list .menu-item');
    const flyingItem = menuList.querySelector('.flying-item');
    const speed = 0.6;
    const maxDelay = 300;
    const minDelay = 50;

    let activeResetTimeout;

    function moveFlyingItemTo(target) {
      const leftOffset = target.offsetLeft;
      const width = target.clientWidth;

      flyingItem.style.width = `${width}px`;
      flyingItem.style.marginLeft = `${leftOffset}px`;
      flyingItem.style.opacity = 1;
    }

    function activeToggle() {
      const activeItem = menuList.querySelector('.menu-item.active');
      if (activeItem) {
        moveFlyingItemTo(activeItem);
      }
    }

    menuToggleItemArr.forEach((toggleBtn) => {
      toggleBtn.addEventListener('mouseenter', () => {
        const link = toggleBtn.querySelector('.menu-link');
        const leftOffset = toggleBtn.offsetLeft;
        const targetWidth = toggleBtn.clientWidth;

        const currentLeft = parseFloat(flyingItem.style.marginLeft) || 0;
        const distance = Math.abs(leftOffset - currentLeft);
        const rawDelay = distance / speed;
        const delay = Math.max(minDelay, Math.min(rawDelay, maxDelay));

        clearTimeout(activeResetTimeout);

        link.classList.add('wait-hover');
        toggleBtn.classList.add('wait-hover');

        const activeItem = menuList.querySelector('.menu-item.active');

        if (activeItem && !toggleBtn.classList.contains('active')) {
          activeItem.classList.add('active-is-hidden');
        }

        if (toggleBtn.classList.contains('active')) {
          activeResetTimeout = setTimeout(() => {
            toggleBtn.classList.remove('active-is-hidden');
          }, delay);
        }

        flyingItem.style.opacity = 1;
        flyingItem.style.width = `${targetWidth}px`;
        flyingItem.style.marginLeft = `${leftOffset}px`;

        setTimeout(() => {
          link.classList.remove('wait-hover');
          toggleBtn.classList.remove('wait-hover');
        }, delay);
      });
    });

    menuList.addEventListener('mouseleave', () => {
      const activeItem = menuList.querySelector('.menu-item.active');
      if (activeItem) {
        const leftOffset = activeItem.offsetLeft;
        const currentLeft = parseFloat(flyingItem.style.marginLeft) || 0;
        const distance = Math.abs(leftOffset - currentLeft);
        const rawDelay = distance / speed;
        const delay = Math.max(minDelay, Math.min(rawDelay, maxDelay));

        clearTimeout(activeResetTimeout);

        flyingItem.style.width = `${activeItem.clientWidth}px`;
        flyingItem.style.marginLeft = `${leftOffset}px`;

        activeResetTimeout = setTimeout(() => {
          activeItem.classList.remove('active-is-hidden');
        }, delay);
      }
    });

    requestAnimationFrame(() => {
      setTimeout(() => {
        activeToggle();
      }, 50);
    });
  }
}

